export const MOCK_DATASETS = [
  { id: 'ds-001', name: 'Global_User_Profiles', dock: 'Core Identities', owner: 'Identity Team', rows: '45.2M', health: 98, updated: '2 hours ago', type: 'PostgreSQL', tags: ['PII', 'Production'], note: 'Primary source of truth for user attributes and auth metadata.' },
  { id: 'ds-002', name: 'Realtime_Telemetry_Events', dock: 'Stream Harbor', owner: 'Platform Eng', rows: '1.2B', health: 92, updated: 'Live', type: 'Kafka', tags: ['High Volume', 'Raw'], note: 'Unfiltered clickstream data from mobile and web clients.' },
  { id: 'ds-003', name: 'Aggregated_Monthly_Revenue', dock: 'Finance Bay', owner: 'RevOps', rows: '12.5K', health: 100, updated: '1 day ago', type: 'Snowflake', tags: ['Certified', 'Financial'], note: 'Cleaned and audited revenue figures for executive reporting.' },
  { id: 'ds-004', name: 'Marketing_Campaign_Results', dock: 'Growth Dock', owner: 'Marketing Analytics', rows: '2.4M', health: 85, updated: '5 hours ago', type: 'BigQuery', tags: ['External', 'Reporting'], note: 'Consolidated results from Google Ads and Meta platforms.' },
  { id: 'ds-005', name: 'Product_Inventory_Sync', dock: 'Operations', owner: 'Supply Chain', rows: '850K', health: 95, updated: '15 mins ago', type: 'MySQL', tags: ['Critical', 'Internal'], note: 'Real-time stock levels across all regional warehouses.' },
  { id: 'ds-006', name: 'Customer_Support_Tickets', dock: 'Service Bay', owner: 'CX Team', rows: '5.1M', health: 88, updated: '1 hour ago', type: 'Zendesk API', tags: ['Text Data', 'PII'], note: 'Historical record of support interactions and resolutions.' },
];

export const MOCK_REQUESTS = [
  { id: 'req-101', user: 'Alex Chen', role: 'Data Scientist', dataset: 'Global_User_Profiles', reason: 'Training churn prediction model v2', status: 'pending', date: '2023-10-24', priority: 'High' },
  { id: 'req-102', user: 'Sarah Jenkins', role: 'Financial Analyst', dataset: 'Realtime_Telemetry_Events', reason: 'Ad-hoc analysis for Q3 report', status: 'pending', date: '2023-10-25', priority: 'Medium' },
  { id: 'req-103', user: 'Mike Ross', role: 'Product Manager', dataset: 'Aggregated_Monthly_Revenue', reason: 'Feature usage correlation', status: 'approved', date: '2023-10-20', priority: 'Low' },
];

export const LINEAGE_GRAPH_DATA = {
  nodes: [
    { id: '0', name: 'Raw_Events', symbolSize: 30, category: 0, value: 'Kafka' },
    { id: '1', name: 'User_DB', symbolSize: 30, category: 0, value: 'Postgres' },
    { id: '2', name: 'Event_Parser', symbolSize: 20, category: 1, value: 'Airflow' },
    { id: '3', name: 'Clean_Events', symbolSize: 40, category: 2, value: 'Snowflake' },
    { id: '4', name: 'Identity_Resolution', symbolSize: 20, category: 1, value: 'dbt' },
    { id: '5', name: 'Golden_Records', symbolSize: 50, category: 2, value: 'Snowflake' },
    { id: '6', name: 'BI_Dashboard', symbolSize: 35, category: 3, value: 'Tableau' }
  ],
  links: [
    { source: '0', target: '2' },
    { source: '2', target: '3' },
    { source: '1', target: '4' },
    { source: '3', target: '4' },
    { source: '4', target: '5' },
    { source: '5', target: '6' }
  ],
  categories: [
    { name: 'Source Dock' },
    { name: 'Transformation Stream' },
    { name: 'Refined Harbor' },
    { name: 'Consumption Port' }
  ]
};

export const FAQ_DATA = [
  {
    question: "How does DataHarbor handle data privacy during discovery?",
    answer: "DataHarbor only indexes metadata and schema definitions. Your actual data remains in your secure storage. We use PII detection beacons to automatically tag sensitive columns so your governance team can restrict access instantly."
  },
  {
    question: "Can I connect my own cloud storage to this demo?",
    answer: "This is a simulated environment for demonstration purposes. In a live production setup, you can connect AWS S3, Google Cloud Storage, Snowflake, and 50+ other sources via our secure SDK or managed connectors."
  },
  {
    question: "What is a 'Data Dock'?",
    answer: "A Data Dock is a logical grouping of related datasets, often aligned with a business unit (e.g., Marketing Dock) or a data stage (e.g., Raw Dock). It helps teams organize thousands of tables into navigable sectors."
  },
  {
    question: "How is the 'Health Score' calculated?",
    answer: "Our Quality Beacons monitor four key signals: Freshness (is data arriving on time?), Completeness (are there nulls?), Schema Consistency (did the columns change?), and Distribution (are values within expected ranges?)."
  },
  {
    question: "What support plans are available for the 'Full Harbor' tier?",
    answer: "The Full Harbor tier includes 24/7 Priority Crew support, a dedicated Data Success Manager, and 99.9% uptime SLAs for your metadata catalog availability."
  }
];